

















import { Component, Prop, Vue } from 'vue-property-decorator';
import BillingService from '@/api/BillingService';

import FilledButton from '../FilledButton/FilledButton.vue';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import DateUtils from '@/utils/DateUtils';
import CoinIcon from '@/components/icons/WidgetCoin.vue';
import { EBusinessUserType } from '@/store/modules/businessTypes';
import { getBillingIsHidden } from '@/utils/billing';

@Component({
  components: {
    FilledButton,
    CoinIcon
  }
})
export default class BannerReactiveBilling extends Vue {
  @Prop() featureName!: string;

  loading = false;

  service: BillingService = new BillingService();

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get billingStatus() {
    return this.business.subscriptionStatus;
  }

  get subscription() {
    return this.$store.getters['business/getBillingSubscription'] || {};
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  // Same as the activate banner: reactivating the plan is its only action, so it
  // has nothing left to do once billing is hidden (TWISM-19008).
  get billingIsHidden() {
    return getBillingIsHidden();
  }

  get text() {
    const date = DateUtils.formattedDate({
      date: this.subscription.billingCycle.endAt
    });
    return `This campaign will remain available until the end of the Coin Network cycle on <strong>${date}</strong>.
To continue enjoying ${
      this.featureName
    }, please reactivate your Coin Network plan.`;
  }

  async onActivateBilling(loading: boolean = true) {
    try {
      if (
        this.$store.getters['business/getManagerRole'] !==
        EBusinessUserType.OWNER
      ) {
        this.$notification(
          "You don't have permission to upgrade your account",
          'error'
        );
        return;
      }

      this.loading = loading;
      if (!loading) this.$showLoader();

      const {
        overview,
        features
      } = await this.service.getOverviewAndActivedFeatures();

      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: `coinNetworkReactivationModal`,
          hideCancelButton: false,
          icon: '',
          mobileFullScreen: true
        }),
        {
          subscription: overview,
          features,
          origin: 'To-Be-Canceled Banner'
        }
      );
    } finally {
      if (!loading) this.$hideLoader();

      this.loading = false;
    }
  }
}
